import { gql, useMutation } from "@apollo/client";

const DELETE_BEFORE_AND_AFTER = gql`
  mutation DeleteBeforeAndAfterProject($projectId: ID!) {
    deleteBeforeAndAfterProject(projectId: $projectId)
  }
`;

export const useDeleteBeforeAndAfterProjectMutation = () => {
  const [deleteBeforeAndAfterMutation, { loading, error, data }] =
    useMutation(DELETE_BEFORE_AND_AFTER);

  const deleteBeforeAndAfterProject = async (projectId: string) => {
    try {
      const response = await deleteBeforeAndAfterMutation({
        variables: { projectId },
      });
      return response.data?.deleteBeforeAndAfterProject ?? false;
    } catch (deleteError) {
      console.error("Error deleting before & after project:", deleteError);
      throw deleteError;
    }
  };

  return {
    deleteBeforeAndAfterProject,
    loading,
    error,
    data,
  };
};
